import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Row, Col, Badge, Button  ,Spinner} from "react-bootstrap";
import {
  getUserDetail,
  getUserEvent,
} from "../../services/UserServices/UserService";
import { useParams } from "react-router-dom";
 
import placeImage from "../../images/image.png"
import PageTitle from "../layouts/PageTitle";
const UserDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [user, setUser] = useState();
  const [userEvent, setUserEvent] = useState([]);
  const { id } = useParams();
 
    
     const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      
      try {
        setLoading(true); 
        const res = await getUserDetail(id);
        
        setUser(res?.data?.data);
      } catch (error) {
        console.error(error?.response?.data?.message);
      }
      finally{
        setLoading(false);
      }
    };
    if (id) {
      getData();
    }
   }, []);

  useEffect(() => {
    const getEvent = async () => {
      try {
        const res = await getUserEvent(id);
        
        setUserEvent(res?.data?.data);
        
      } catch (error) {
        console.error(error?.response?.data?.message);
      }
    };
    if (id) {
      getEvent();
    }
  }, []);

  

  const co_Hosts = [
    {
      id: 1,
      name: "abc",
      phone: 2132323312321,
    },
    {
      id: 2,
      name: "xyz",
      phone: 2132323312321,
    },
    {
      id: 3,
      name: "uvw",
      phone: 2132323312321,
    },
    {
      id: 4,
      name: "sdf",
      phone: 2132323312321,
    },
  ];

  const guests = [
    {
      id: 1,
      name: "abc",
      phone: 2132323312321,
      invites:"Wedding , Haldi , Mehandi",
      status:"Accepted"
    },
    {
      id: 2,
      name: "xyz",
      phone: 2132323312321,
       invites:"Wedding , Haldi , Mehandi",
      status:"Rejected"
    },
    {
      id: 3,
      name: "uvw",
      phone: 2132323312321, invites:"Wedding , Haldi , Mehandi",
      status:"Accepted"
    },
    {
      id: 4,
      name: "sdf",
      phone: 2132323312321, invites:"Wedding , Haldi , Mehandi",
      status:"Rejected"
    },
  ];

 
    //display only 4 events 
    const displayedEvents = userEvent.slice(0, 3);
 
 
 


   if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
        <Spinner animation="border" variant="primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }
  return (
    <div >
           <PageTitle
  motherMenu="User List"
  activeMenu="User Detail"
  pathBack={true}   
/>
      {/* -------- User Detail Card -------- */}
      

      <Card className="shadow-lg profile-card mb-5">
        <Row className="g-0">
          {/* Left side - Profile Image */}
          <Col
            md={4}
            className="d-flex align-items-center justify-content-center"
          >
          <img
  className="img-fluid rounded-md user-image"
  src={
    user?.couplePhoto
      ? `https://managemyshaadib.s3.ap-south-1.amazonaws.com/${user.couplePhoto}`
      : "https://img.freepik.com/premium-vector/vector-flat-illustration-grayscale-avatar-user-profile-person-icon-profile-picture-business-profile-woman-suitable-social-media-profiles-icons-screensavers-as-templatex9_719432-1339.jpg"
  }
  alt="Profile"
/>

          </Col>

          {/* Right side - Details */}
          <Col md={8}>
            <Card.Body>
              <Card.Title
                className="mb-3 fs-3 fw-bold"
                style={{ color: "#3C4464" }}
              >
                {user?.hostName}
              </Card.Title>

              {/* Details */}
              <div className="mb-2 d-flex">
                <strong
                  className="me-4 w-50"
                  style={{ color: "#87C55F", fontWeight: "600" }}
                >
                  Bride Name:
                </strong>
                <span style={{ color: "black" }}>{user?.brideName ? user?.brideName :"brdie"} </span>
              </div>
              <div className="mb-2 d-flex">
                <strong
                  className="me-4 w-50"
                  style={{ color: "#87C55F", fontWeight: "600" }}
                >
                  Groom Name:
                </strong>
                <span style={{ color: "black" }}> {user?.groomName ?user?.groomName:"groom"}</span>
              </div>
              <div className="mb-2 d-flex">
                <strong
                  className="me-4 w-50"
                  style={{ color: "#87C55F", fontWeight: "600" }}
                >
                  Host Side:
                </strong>
                <span
                  className={`${
                    user?.hostSide === "Groom" ? "Groom" : "Bride"
                  }`}
                >
                  {user?.hostSide ? user?.hostSide :"Bride"  }
                </span>
              </div>
              <div className="mb-2 d-flex">
                <strong
                  className="me-4 w-50"
                  style={{ color: "#87C55F", fontWeight: "600" }}
                >
                  Phone Number:
                </strong>
                <span style={{ color: "black" }}>
                  {user?.countryCode} {user?.phoneNumber}
                </span>
              </div>

              <div className="mb-2 d-flex">
                <strong
                  className="me-4 w-50"
                  style={{ color: "#87C55F", fontWeight: "600" }}
                >
                  Created At:
                </strong>
                <span style={{ color: "black" }}>
                  {" "}
                  {new Date(user?.createdAt).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  })}
                </span>
              </div>

              <div className="mb-2 d-flex">
                <strong
                  className="me-4 w-50"
                  style={{ color: "#87C55F", fontWeight: "600" }}
                >
                  Updated At:
                </strong>
                <span style={{ color: "black" }}>
                  {" "}
                  {new Date(user?.updatedAt).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  })}{" "}
                </span>
              </div>
            </Card.Body>
          </Col>
        </Row>
      </Card>

   {/* User Events */}

{displayedEvents && displayedEvents.length>0 && (<>  <h2
        className=" mb-4 user-detail-title font-fm"
        style={{ fontSize: "50px" }}
      >
        Events
      </h2>
      <Card className="shadow-lg event-card mb-5 roun" >
        <Card.Body  style={{
      maxHeight: "300px",   // adjust height as needed
      overflowY: "auto",
    }} >
          {displayedEvents.map((event) => (
            <div
              key={event._id}
              className="event-item mb-4 p-3 rounded d-flex justify-content-between align-items-center"
            >
              {/* Left side - Event details */}
              <div>
                <h5 className="fw-bold mb-3">{event?.name.name}</h5>

                <div className="d-flex justify-content-between mb-1">
                  <strong className="label-text me-5">Date:</strong>
                  <span>
                    {" "}
                    {new Date(event?.eventDate).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}
                  </span>
                </div>

               

                <div className="d-flex justify-content-between mb-1">
                  <strong className="label-text me-5">Venue:</strong>
                  <span>{event?.eventVenue?event?.eventVenue:"NAN"}</span>
                </div>

                <div className="d-flex justify-content-between mb-1">
                  <strong className="label-text">Theme:</strong>
                  <span>{event?.theme?.name?event?.theme?.name:"NAN"}</span>
                </div>

                <div className="d-flex justify-content-between mb-1">
                  <strong className="label-text">Dress Code:</strong>
                  <span>{event?.dressCode?.name ? event?.dressCode?.name : "NAN"}</span>
                </div>

                <div className="d-flex justify-content-between mb-1">
                  <strong className="label-text">Dress Color:</strong>
                  <span>{event?.dressColor?.name?event?.dressColor?.name:"NAN"}</span>
                </div>
              </div>

              {/* Right side - Buttons */}
              <div className="ms-3">
              {event.subEvents && event.subEvents.length>0 && (<>  
              
              <Button
                  className="me-2 #87C55F-btn"
                  onClick={() => navigate(`/sub-events/${id}/${event._id}`,{
      state: { history: {event, user} } 
    })}
                >
                  Sub Events
                </Button></>)}

                 <Button
                  className="me-2 #87C55F-btn"
                  onClick={() => navigate(`/guests/${id}/${event._id}`,{
      state: { history: {event, user} } 
    })}
                >
                Guests
                </Button>

<Button
                  className="me-2 #87C55F-btn"
                  onClick={() => navigate(`/tasks/${id}/${event._id}`,{
      state: { history: {event, user} } 
    } )}
                >
                  Tasks
                </Button>
                 
                
              </div>
            </div>
          ))}
          <div style={{textAlign:"right", color:"#87C55F" , cursor:"pointer"}}   onClick={() => navigate(`/user_events/${id}`,{
      state: { history: {user} } 
    } )} > see all →</div>
        </Card.Body>

      </Card> 
    </>)}

    


{/* -------- Co-Hosts Card -------- */}
      <h2 className=" mb-4 user-detail-title font-fm" style={{ fontSize: "50px" }}>
        Co-Hosts
      </h2>
      <Card className="shadow-lg   cohost-card mb-5 rounded-3">
        <Card.Body style={{
      maxHeight: "300px",   // adjust height as needed
      overflowY: "auto",
    }}>
          {co_Hosts.map((host) => (
            <div
              key={host.id}
              className="cohost-item mb-3 p-3 rounded d-flex justify-content-between align-items-center"
              style={{ border: "1px solid #eee", background: "#fafafa" }}
            >
              {/* Left side - Co-host details */}
              <div>
                <h5 className="fw-bold mb-2">{host.name}</h5>
                <p className="mb-0 " style={{color:"#87C55F"}}>📞 {host.phone}</p>
              </div>

              {/* Right side - Event button */}
              <Button
                className="#87C55F-btn"
                onClick={() => navigate(`/co-host/${host.id}`,{
      state: { history: { user} } 
    })}
              >
                View Profile
              </Button>
            </div>
          ))}
          <div style={{textAlign:"right", color:"#87C55F" , cursor:"pointer"}}  onClick={() => navigate(`/co_hosts`,{
      state: { history: { user} } 
    })  } > see all →</div>
      
        </Card.Body>
      </Card>



   {/* -------- Guest Card -------- */}
      <h2 className=" mb-4 user-detail-title font-fm" style={{ fontSize: "50px" }}>
       Guests
      </h2>
      <Card className="shadow-lg   cohost-card mb-5 rounded-3">
        <Card.Body   style={{
      maxHeight: "300px",   // adjust height as needed
      overflowY: "auto",
    }}>
          {guests.map((guest) => (
            <div
              key={guest.id}
              className="cohost-item mb-3 p-3 rounded d-flex justify-content-between align-items-center"
              style={{ border: "1px solid #eee", background: "#fafafa" }}
            >
              {/* Left side - Co-host details */}
              <div>
                <h5 className="fw-bold mb-2">{guest.name}</h5>
                <p className="mb-0 " style={{color:"#87C55F"}}>📞 {guest.phone}</p>
                     <div className="fw-bold mb-2" style={{color:"#FFB200"}}>{guest.invites}</div>
              </div>

              {/* Right side - Event button */}
              <div
                className={`${guest?.status==="Accepted"?"acc":"rej"}`}
                
              >
               {guest?.status}
              </div>
            </div>
          ))}
        </Card.Body>
      </Card>


    </div>
  );
};

export default UserDetails;
